import ApolloClient from "apollo-client";

import { createLink } from "apollo-absinthe-upload-link";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloLink } from "apollo-link";

import { IntrospectionFragmentMatcher } from "apollo-cache-inmemory";
import introspectionQueryResultData from "./fragmentTypes.json";

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

const API_URL =
  process.env.NODE_ENV === "production" || true
    ? "https://nes-api.koode.nl/graphql"
    : "http://localhost:4000/graphql";

const link = ApolloLink.from([createLink({ uri: API_URL })]);

const client = new ApolloClient({
  cache: new InMemoryCache({ fragmentMatcher }),
  link
});

export default client;



// WEBPACK FOOTER //
// ./src/graphql/client.ts